import { SidebarModalListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import usePublicationBookingItem from '@hooks/usePublicationBookingItem'

import type { PublicationBookingItemModel } from '@models/types'

interface PublicationBookingItemParams {
  publicationBookingItem: PublicationBookingItemModel,
}

const PublicationBookingItem = (params: PublicationBookingItemParams) => {
  const { publicationBookingItem: initPublicationBookingItem } = params

  const publicationBookingItemPayload = usePublicationBookingItem(initPublicationBookingItem)
  const {
    callbacks: {
      cancelPublicationBookingItem: cancelFn,
    },
    campaign,
    publicationBookingItem,
  } = publicationBookingItemPayload

  const confirmDeletePayload = {
    callbacks: {
      deleteFn: cancelFn,
    },
    strings: {
      confirmString: 'Are you sure? This will cancel and delete the booking and order. It cannot be reversed.',
      deleteString: 'cancel',
      entityName: 'Booking',
      toastText: 'Booking Cancelled',
    },
  }

  return (
    <SidebarModalListItem
      boxProps={{ paddingY: 'medium' }}
      // @ts-expect-error TS2339
      secondaryText={publicationBookingItem?.product?.title}
      // @ts-expect-error TS2339
      title={`${campaign.address}, ${campaign.suburb_name}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon onClick={() => confirmDelete(confirmDeletePayload)} type="delete" />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default PublicationBookingItem
